import React, { useState } from 'react';
import '../App.css';

const About = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <section className={`about-me ${isDarkMode ? 'dark-mode' : 'light-mode'}`} id="about">
      <div className="container">
        <div className="about-content">
          <div className="left-content">
            <h1 className={`about-heading ${isDarkMode ? 'dark-text' : 'light-text'}`}>About Me</h1>
            <center>
              <img src="https://media.licdn.com/dms/image/D4D03AQE_7zqOtxUa-A/profile-displayphoto-shrink_200_200/0/1688814902751?e=2147483647&v=beta&t=5SNwh_Q2jA_YANhF2hGCu3rlXSd25LN6RxDsSuZcMm8" alt="Ayush Dey"/>
            </center>
            &nbsp;
            <p className={isDarkMode ? 'dark-text' : 'light-text'}>
              "As a coding enthusiast with a passion for solving complex problems,<br></br> I love nothing more than diving into new projects and finding creative solutions. <br></br>I'm always eager to learn and grow as a developer as well as dedicated to staying current with the latest developments in Web Development , AI/ML and other CS domains. I am always eager to apply my skills to real-world problems. When I'm not coding, you can find me tinkering with projects or participating in hackathons and coding competitions. <br></br><br></br><b>Let's connect and see what we can build together</b>!"
            </p>
            &nbsp;
          </div>
          &nbsp;
          <div className="right-content">
            <b>
            <h1 className={`skills-heading ${isDarkMode ? 'dark-text' : 'light-text'}`}>My Skills</h1>
            <ul className={`skills-list ${isDarkMode ? 'dark-text' : 'light-text'}`}>
              &nbsp;
              <li>React JS</li>
              <li>Node.js</li>
              <li>Express.js</li>
              <li>Angular.js</li>
              <li>MongoDB</li>
              <li>Data Structures and Algorithms</li>
              <li>Oracle SQL</li>
              <li>MySQL</li>
              <li>Python (Libraries)</li>
              <li>Java </li>
              <li>C</li>
              <li>Agile Methodologies</li>
              <li>MS Excel</li>
            </ul>
            </b>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
